import Input from './components/Input';
import Message from './components/Message';
import useSimuladorInteligente from './useSimuladorInteligente';

import backgroundImage from '../../assets/imagens/background-simulador.png';

import './style.css';

const SimuladorInteligente = () => {

    const {
        isLoading,
        history,
        isWritingMessage,
        currentItem,
        messagesEndRef,
        handleSend,
        storedResponseDataRef,
        handleReset,
    } = useSimuladorInteligente();

    return (
        <div
            className='light-theme-page'
            style={{
                height: "100vh",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#242424',
                backgroundImage: `url(${backgroundImage})`
            }}
        >
            <div className='chatWhiteContainer'>
                <div className='chatInnerContainer'>
                    <div className='chatMessagesContainer'>

                        {
                            history.map((item) => (
                                <Message
                                    key={`${item.id}-${item.type}${item.response ? '-response' : ''}`}
                                    item={item}
                                />
                            ))
                        }

                        {
                            (isLoading || isWritingMessage) && (
                                <Message
                                    item={null}
                                    text='...'
                                />
                            )
                        }

                        <div ref={messagesEndRef} />
                    </div>

                    <Input
                        currentItem={currentItem}
                        onSend={handleSend}
                        onReset={handleReset}
                        isLoading={isLoading || isWritingMessage}
                        showResetButton={!!storedResponseDataRef.current}
                    />
                </div>
            </div>
        </div>
    )
};

export default SimuladorInteligente;
